module.exports = __webpack_public_path__ + "img/ic_mpe_headsock_normal.79497397.png";